import { Badge, List, ListSubheader, ListItem, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
import { TicketQueue } from 'helpers/enums';
import { applicationContext } from 'helpers/services';
import { useContext } from 'react';
import { ticketsContext } from '../TicketsContext';


let Queues = () => {
    let { ticketQueues } = useContext(applicationContext);
    let { queue, ticketQueuesCount, updateQueue } = useContext(ticketsContext);

    return (
        <List
            style={{ position: 'sticky', top: 64 }}
            component="nav"
            subheader={<ListSubheader disableSticky>Queues</ListSubheader>}
        >
            {ticketQueues.map(ticketQueue =>
                <ListItem
                    button
                    key={ticketQueue.key}
                    selected={queue === ticketQueue.key}
                    onClick={() => updateQueue(ticketQueue.key)}
                >
                    <ListItemText primary={ticketQueue.value} />
                    {ticketQueue.key !== TicketQueue.TicketsDashboard &&
                        <ListItemSecondaryAction>
                            <Badge
                                max={99999}
                                color="secondary"
                                overlap="rectangular"
                                badgeContent={ticketQueuesCount.getValueByKey(ticketQueue.key)?.toString()}
                            />
                        </ListItemSecondaryAction>
                    }
                </ListItem>
            )}
            <ListItem
                button
                selected={queue === ''}
                onClick={() => updateQueue('')}
            >
                <ListItemText primary="Advanced search" />
            </ListItem>
        </List>
    )
}

export default Queues;